import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppContextProvider } from 'src/context/appContext';
import { LanguageContextProvider } from 'src/context/languageContext';
import Routes from './routes';
import './App.scss';
import Head from './conponents/Head';

function App() {
  return (
    <div className="app-container">
      <LanguageContextProvider>
        <Head />
        <AppContextProvider>
          <Router>
            <Routes />
          </Router>
        </AppContextProvider>
      </LanguageContextProvider>
    </div>
  );
}

export default App;
